import { useDispatch, useSelector } from "react-redux";
import {
  deleteQuestion,
  getLaws,
  getQuizQuestions,
  setNewQuestionForm,
  setQuestionForm,
  setState,
} from "./redux/lawCollegeSlice";
import { useEffect } from "react";
import Popup from "../Popup";
import EditOrViewLawCollegeQuiz from "./EditOrViewLawCollegeQuiz";
import CommonTable from "./CommonTable";

export default function GetQuizQuestions() {
  const {
    newQuestionForm,
    questionsList,
    openPopUp,
    mode,
    categories,
    selectedCategory,
  } = useSelector((state) => state.lawCollegeQuiz);
  const { questions, total_count, filtered_count, limit, offset } =
    questionsList;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setState({
        key: "selectedCategory",
        value: "",
      })
    );
  }, [dispatch]);

  const handleLevelChange = (e) => {
    dispatch(
      setNewQuestionForm({ key: "difficulty_level", value: e.target.value })
    );
    dispatch(
      getQuizQuestions({
        body: {
          offset,
          limit,
          level: e.target.value,
          law: selectedCategory || "",
        },
      })
    );
  };
  const handleLevelChangeNew = (e) => {
    dispatch(
      setState({
        key: "selectedCategory",
        value: e.target.value,
      })
    );
    dispatch(
      getQuizQuestions({
        body: {
          offset,
          limit,
          law: e.target.value,
          level: newQuestionForm.difficulty_level || "",
        },
      })
    );
  };
  const userId = JSON.parse(localStorage.getItem("user"))?.id;

  useEffect(() => {
    dispatch(getQuizQuestions({ body: {} }));
    dispatch(getLaws());
  }, [dispatch]);

  // const filteredQuestions = newQuestionForm.difficulty_level
  //   ? questions.filter((q) => q.level === newQuestionForm.difficulty_level)
  //   : questions;

  const handleEditOrView = (question, val) => {
    dispatch(setState({ key: "openPopUp", value: true }));
    dispatch(setState({ key: "mode", value: val }));
    console.log("question", question);
    dispatch(
      setQuestionForm({
        questionId: question.id,
        question: question.question,
        option_a: question.options?.A || "",
        option_b: question.options?.B || "",
        option_c: question.options?.C || "",
        option_d: question.options?.D || "",
        correct_option: question.correct_option || "",
        difficulty_level: question.level || question.difficulty_level || "",
        created_by: question.created_by_name || "",
        created_at: question.created_at || "",
        updated_by: question.updated_by_name || "",
        updated_at: question.updated_at || "",
        created_by_user_id: question.created_by || "",
        updated_at_user_id: question.updated_by || "",
      })
    );
  };
  const handleDeleteQuestion = async (id, updated_by) => {
    console.log("", updated_by);
    if (window.confirm("Are you sure to delete the question ?")) {
      try {
        await dispatch(
          deleteQuestion({
            id,
            updated_by,
          })
        ).unwrap();

        alert("Question deleted successfully.");
        dispatch(getQuizQuestions());
      } catch (error) {
        if (error?.response?.status === 409) {
          alert("This question already exists.");
        } else {
          alert(
            "Failed to add question: " + (error?.message || "Unknown error")
          );
        }
        console.error("Error adding question:", error);
      }
    }
  };
  const columns = [
    { key: "id", label: "ID" },
    { key: "question", label: "Question" },
    { key: "option_A", label: "Option A" },
    { key: "option_B", label: "Option B" },
    { key: "option_C", label: "Option C" },
    { key: "option_D", label: "Option D" },
    { key: "correct_option", label: "Correct Option" },
    { key: "difficulty_level", label: "Difficulty Level" },
    { key: "law_name", label: "Law Name" },
    { key: "action", label: "Action (s)" },
  ];

  const data = questions
    // ?.filter(
    //   (q) =>
    //     !newQuestionForm.difficulty_level ||
    //     q.level === newQuestionForm.difficulty_level ||
    //     q.difficulty_level === newQuestionForm.difficulty_level
    // )
    ?.map((q, index) => ({
      id: q.id,
      question: q.question || "-",
      option_A: q.options?.A || "-",
      option_B: q.options?.B || "-",
      option_C: q.options?.C || "-",
      option_D: q.options?.D || "-",
      correct_option: q.correct_option || "-",
      difficulty_level: q.level || q.difficulty_level || "-",
      law_name: q.law_name || "-",
      action: (
        <p style={{ display: "flex", gap: "5px" }}>
          <button onClick={() => handleEditOrView(q, "view")}>View</button>
          <button onClick={() => handleEditOrView(q, "edit")}>Edit</button>
          <button onClick={() => handleDeleteQuestion(q.id, userId)}>
            Delete
          </button>
        </p>
      ),
    }));

  // questions?.length > 0
  //   ? questions.map((q, index) => ({
  //       id: q.id,
  //       question: q.question || "-",
  //       option_A: q.options?.A || "-",
  //       option_B: q.options?.B || "-",
  //       option_C: q.options?.C || "-",
  //       option_D: q.options?.D || "-",
  //       correct_option: q.correct_option || "-",
  //       difficulty_level: q.level || q.difficulty_level || "-",
  //       action: (
  //         <p style={{ display: "flex", gap: "5px" }}>
  //           <button onClick={() => handleEditOrView(q, "view")}>View</button>
  //           <button onClick={() => handleEditOrView(q, "edit")}>Edit</button>
  //           <button onClick={() => handleDeleteQuestion(q.id, q.updated_by)}>
  //             Delete
  //           </button>
  //         </p>
  //       ),
  //     }))
  //   : [];

  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Law College Quiz Questions
          </h3>

          <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
            {/* Question Level Select */}

            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Select a Law
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={selectedCategory}
                  onChange={handleLevelChangeNew}
                >
                  <option value="">All</option>
                  {categories
                    ?.slice() // make a shallow copy to avoid mutating original array
                    .sort((a, b) => a.name.localeCompare(b.name)) // alphabetical sort
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Select the Question's Difficulty Level{" "}
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={newQuestionForm.difficulty_level}
                  onChange={handleLevelChange}
                >
                  <option value="">All</option>
                  <option value="advanced">Advanced Level</option>
                  <option value="basic">Basic Level</option>
                  <option value="docmaster">Docmaster</option>
                  <option value="ultra">Ultra Level</option>
                </select>
              </div>
            </div>
            {/* {filteredQuestions?.length === 0 ? (
              <p className="text-center text-gray-600">
                No questions available yet
              </p>
            ) : (
              <div className="table-responsive p-2 bg-white rounded-3 shadow">
                <table className="table table-striped table-bordered text-15">
                  <thead className="bg-gray-200 text-gray-700 text-center">
                    <tr>
                      <th>ID</th>
                      <th>Question</th>
                      <th>Option A</th>
                      <th>Option B</th>
                      <th>Option C</th>
                      <th>Option D</th>
                      <th>Correct Option</th>
                      <th>Difficulty Level</th>
                      {/* <th>Created At</th> */}
            {/* <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredQuestions.map((q, idx) => (
                      <tr key={q.id || idx}>
                        <td>{idx + 1}</td>
                        <td>{q.question}</td>
                        <td>{q.options?.A || "-"}</td>
                        <td>{q.options?.B || "-"}</td>
                        <td>{q.options?.C || "-"}</td>
                        <td>{q.options?.D || "-"}</td>
                        <td>{q.correct_option}</td>
                        <td>{q.level || q.difficulty_level}</td>
                        <td>
                          <p style={{ display: "flex" }}>
                            <button
                              onClick={() => {
                                handleEditOrView(q, "view");
                              }}
                            >
                              View
                            </button>
                            <button
                              onClick={() => {
                                handleEditOrView(q, "edit");
                              }}
                            >
                              Edit
                            </button>
                            <button
                              onClick={() =>
                                handleDeleteQuestion(q.id, q.updated_by)
                              }
                            >
                              Delete
                            </button>
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )} */}
            {/* Questions Table */}
            <div style={{ height: "50vh", overflow: "auto" }}>
              <CommonTable
                total={total_count}
                filteredCount={filtered_count}
                columns={columns}
                data={data || []}
                // initialRowsPerPage={limit || 100}
                initialRowsPerPage={100}
                searchableKeys={[
                  "id",
                  "question",
                  "law_name",
                  "option_A",
                  "option_B",
                  "option_C",
                  "option_D",
                ]}
                fetchData={({ limit, offset }) =>
                  dispatch(
                    getQuizQuestions({
                      body: {
                        limit,
                        offset,
                        level: newQuestionForm.difficulty_level,
                        law: selectedCategory,
                      },
                    })
                  )
                }
              />
            </div>

            {openPopUp && (
              <Popup
                title={mode === "view" ? "View Question" : "Edit Question"}
                onClose={() => {
                  dispatch(setState({ key: "openPopUp", value: false }));
                  dispatch(setState({ key: "mode", value: "" }));
                }}
                maxWidth="700px"
                minHeight="600px"
              >
                <EditOrViewLawCollegeQuiz />
              </Popup>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
